<template>
  <v-container fluid class="pa-4">
    <v-row dense>
      <!-- Zgjedhja e dites dhe e udhetimit -->
      <v-col cols="12" md="4" lg="3">
        <v-card outlined class="mb-3">
          <v-card-text class="pb-2">
            <v-menu
              v-model="menuDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  :label="$t('history.date')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="date" :max="sot" @input="menuDate = false" />
            </v-menu>
          </v-card-text>

          <v-card-text class="pt-2">
            <div v-if="loadingRides" class="text-center py-4">
              <v-progress-circular indeterminate size="24" color="primary" />
            </div>

            <div v-else-if="!rides.length" class="text-center py-6 grey--text text-body-2">
              {{ $t('history.no_rides') }}
            </div>

            <div v-else>
              <!-- Kerkimi punon mbi listen e ngarkuar: pa kerkese te re ne
                   server, ndaj filtron ndersa shkruan. -->
              <v-text-field
                v-if="!selected"
                v-model="kerkimi"
                :placeholder="$t('history.search_driver')"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
                class="mb-2"
              />

              <!-- Kur nje udhetim eshte i hapur, lista reduktohet vetem te ai:
                   keshtu duket menjehere cilin autobus po shikon. -->
              <v-btn
                v-if="selected"
                x-small
                text
                color="primary"
                class="mb-1 px-1"
                @click="mbyllZgjedhjen"
              >
                <v-icon x-small left>mdi-arrow-left</v-icon>
                {{ $t('history.all_rides') }}
              </v-btn>

              <v-list dense class="py-0">
              <v-list-item
                v-for="r in listaEDukshme"
                :key="r.id"
                :class="{ 'primary--text': selected && selected.id === r.id }"
                @click="open(r)"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-medium">
                    {{ r.bus_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    {{ ora(r.started_at) }}
                    <span v-if="r.finished_at">– {{ ora(r.finished_at) }}</span>
                    · {{ r.driver_name }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    <span v-if="r.points">
                      {{ r.halts }} {{ $t('history.halts') }} ·
                      {{ minuta(r.halt_seconds) }}
                    </span>
                    <span v-else class="grey--text">{{ $t('history.no_track') }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              </v-list>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Harta dhe qendrimet -->
      <v-col cols="12" md="8" lg="9">
        <v-card outlined>
          <!-- Te njejtat shtresa harte si te ndjekja live, dhe e njejta
               zgjedhje e ruajtur: perdoruesi e cakton nje here. -->
          <div class="pa-2 d-flex flex-wrap" style="gap: 6px">
            <v-btn
              v-for="s in tileStyles"
              :key="s.key"
              x-small
              depressed
              :color="tileStyle === s.key ? 'primary' : ''"
              @click="setTile(s.key)"
            >
              {{ s.label }}
            </v-btn>
          </div>

          <v-card-text class="pa-0" style="position: relative">
            <div v-if="loadingTrack" class="loader-over">
              <v-progress-circular indeterminate color="primary" />
            </div>

            <l-map
              ref="map"
              :zoom="zoom"
              :center="center"
              :options="{ zoomControl: true }"
              style="height: 460px; width: 100%; z-index: 1"
            >
              <l-tile-layer :url="url" :attribution="attribution" />

              <!-- Vija ndahet ne pjese: ngjyra tregon shpejtesine, ndaj
                   pritja duket pa lexuar asnje numer. -->
              <l-polyline
                v-for="(seg, i) in segments"
                :key="'s' + i"
                :lat-lngs="seg.pts"
                :color="seg.color"
                :weight="5"
                :opacity="0.9"
              />

              <!-- Nisja dhe mbarimi: pika e pare dhe e fundit e gjurmes. -->
              <l-marker v-if="pikaENisjes" :lat-lng="pikaENisjes" :icon="ikonaNisjes">
                <l-tooltip>
                  <div class="halt-tip">
                    <strong>{{ $t('history.ride_start') }}</strong><br />
                    {{ koha(points[0].recorded_at) }}
                  </div>
                </l-tooltip>
              </l-marker>

              <l-marker v-if="pikaEMbarimit" :lat-lng="pikaEMbarimit" :icon="ikonaMbarimit">
                <l-tooltip>
                  <div class="halt-tip">
                    <strong>{{ $t('history.ride_end') }}</strong><br />
                    {{ koha(points[points.length - 1].recorded_at) }}
                  </div>
                </l-tooltip>
              </l-marker>

              <l-circle-marker
                v-for="(h, i) in halts"
                :key="'h' + i"
                :ref="'halt' + i"
                :lat-lng="[h.lat, h.lng]"
                :radius="haltIZgjedhur === i ? 13 : (h.for_students ? 9 : 6)"
                :color="h.for_students ? '#1b5e20' : '#ef6c00'"
                :fill-color="h.for_students ? '#43a047' : '#ffb74d'"
                :fill-opacity="0.9"
              >
                <l-tooltip>
                  <div class="halt-tip">
                    <div class="halt-tip__head">
                      <strong>{{ minuta(h.seconds) }}</strong>
                      <span>{{ koha(h.arrived_at) }} – {{ koha(h.departed_at) }}</span>
                    </div>

                    <template v-if="h.for_students">
                      <!-- Emrat njeri nen tjetrin: nje liste horizontale behet
                           e palexueshme sapo kalojne tre nxenes. -->
                      <div v-if="h.boarded_names.length" class="halt-tip__group">
                        <span class="halt-tip__label">{{ $t('history.boarded') }}</span>
                        <ul class="halt-tip__names">
                          <li v-for="(n, k) in h.boarded_names" :key="'b' + k">{{ n }}</li>
                        </ul>
                      </div>

                      <div v-if="h.dropped_names.length" class="halt-tip__group">
                        <span class="halt-tip__label">{{ $t('history.dropped') }}</span>
                        <ul class="halt-tip__names">
                          <li v-for="(n, k) in h.dropped_names" :key="'d' + k">{{ n }}</li>
                        </ul>
                      </div>
                    </template>

                    <div v-else class="halt-tip__group">
                      {{ $t('history.not_for_students') }}
                    </div>
                  </div>
                </l-tooltip>
              </l-circle-marker>

              <!-- Nxenes te shenuar jashte cdo qendrimi: zakonisht zbritja e
                   fundit, ku shoferi e mbyll udhetimin brenda sekondash. -->
              <l-circle-marker
                v-for="(m, i) in marksMeVend"
                :key="'m' + i"
                :lat-lng="[m.lat, m.lng]"
                :radius="7"
                color="#5e35b1"
                fill-color="#b39ddb"
                :fill-opacity="0.9"
              >
                <l-tooltip>
                  <div class="halt-tip">
                    <div class="halt-tip__head">
                      <strong>{{ $t('history.marked_only') }}</strong>
                      <span>{{ koha(m.at) }}</span>
                    </div>

                    <div v-if="m.boarded_names.length" class="halt-tip__group">
                      <span class="halt-tip__label">{{ $t('history.boarded') }}</span>
                      <ul class="halt-tip__names">
                        <li v-for="(n, k) in m.boarded_names" :key="'mb' + k">{{ n }}</li>
                      </ul>
                    </div>

                    <div v-if="m.dropped_names.length" class="halt-tip__group">
                      <span class="halt-tip__label">{{ $t('history.dropped') }}</span>
                      <ul class="halt-tip__names">
                        <li v-for="(n, k) in m.dropped_names" :key="'md' + k">{{ n }}</li>
                      </ul>
                    </div>
                  </div>
                </l-tooltip>
              </l-circle-marker>
            </l-map>
          </v-card-text>
        </v-card>

        <v-card v-if="selected" outlined class="mt-3">
          <v-card-title class="text-subtitle-1 py-2">
            {{ $t('history.halts_title') }}
            <v-spacer />
            <span class="text-caption grey--text">
              {{ halts.length }} · {{ minuta(totalSeconds) }}
            </span>
          </v-card-title>

          <v-divider />

          <div v-if="!halts.length" class="text-center py-6 grey--text text-body-2">
            {{ $t('history.no_halts') }}
          </div>

          <v-simple-table v-else dense>
            <thead>
              <tr>
                <th>{{ $t('history.arrived') }}</th>
                <th>{{ $t('history.departed') }}</th>
                <th>{{ $t('history.waited') }}</th>
                <th>{{ $t('history.reason') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(h, i) in halts"
                :key="i"
                class="halt-row"
                :class="{ 'halt-row--active': haltIZgjedhur === i }"
                @click="shkoTeQendrimi(h, i)"
              >
                <td>{{ koha(h.arrived_at) }}</td>
                <td>{{ koha(h.departed_at) }}</td>
                <td class="font-weight-medium">{{ minuta(h.seconds) }}</td>
                <td>
                  <template v-if="h.for_students">
                    <div v-if="h.boarded_names.length" class="mb-1">
                      <v-chip x-small color="green lighten-4" text-color="green darken-3" class="mr-1">
                        {{ h.boarded_names.length }} {{ $t('history.boarded') }}
                      </v-chip>
                      <span class="text-caption">{{ h.boarded_names.join(', ') }}</span>
                    </div>
                    <div v-if="h.dropped_names.length">
                      <v-chip x-small color="blue lighten-5" text-color="blue darken-3" class="mr-1">
                        {{ h.dropped_names.length }} {{ $t('history.dropped') }}
                      </v-chip>
                      <span class="text-caption">{{ h.dropped_names.join(', ') }}</span>
                    </div>
                  </template>
                  <span v-else class="text-caption grey--text">
                    {{ $t('history.not_for_students') }}
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <template v-if="marks.length">
            <v-divider />
            <v-card-subtitle class="text-caption font-weight-bold pb-1">
              {{ $t('history.marked_only') }}
            </v-card-subtitle>
            <v-simple-table dense>
              <tbody>
                <tr v-for="(m, i) in marks" :key="'mr' + i">
                  <td style="width: 90px">{{ koha(m.at) }}</td>
                  <td>
                    <div v-if="m.boarded_names.length">
                      <span class="text-caption font-weight-bold">{{ $t('history.boarded') }}:</span>
                      <span class="text-caption"> {{ m.boarded_names.join(', ') }}</span>
                    </div>
                    <div v-if="m.dropped_names.length">
                      <span class="text-caption font-weight-bold">{{ $t('history.dropped') }}:</span>
                      <span class="text-caption"> {{ m.dropped_names.join(', ') }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>

          <v-divider />

          <v-card-text class="py-3">
            <p class="text-caption font-weight-bold mb-2">{{ $t('history.legend') }}</p>

            <div class="legend">
              <div class="legend__item">
                <i class="legend__pin" style="background: #2e7d32">A</i>
                <span>
                  <b>{{ $t('history.ride_start') }}</b>
                  <em>{{ $t('history.legend_start_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__pin" style="background: #c62828">B</i>
                <span>
                  <b>{{ $t('history.ride_end') }}</b>
                  <em>{{ $t('history.legend_end_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__dot" style="background: #43a047; border-color: #1b5e20"></i>
                <span>
                  <b>{{ $t('history.legend_halt_students') }}</b>
                  <em>{{ $t('history.legend_halt_students_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__dot" style="background: #ffb74d; border-color: #ef6c00"></i>
                <span>
                  <b>{{ $t('history.legend_halt_road') }}</b>
                  <em>{{ $t('history.legend_halt_road_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__dot" style="background: #b39ddb; border-color: #5e35b1"></i>
                <span>
                  <b>{{ $t('history.marked_only') }}</b>
                  <em>{{ $t('history.legend_marked_desc') }}</em>
                </span>
              </div>
            </div>

            <p class="text-caption font-weight-bold mt-3 mb-2">{{ $t('history.legend_line') }}</p>

            <div class="legend">
              <div class="legend__item">
                <i class="legend__line" style="background: #2e7d32"></i>
                <span>
                  <b>{{ $t('history.legend_moving') }}</b>
                  <em>{{ $t('history.legend_moving_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__line" style="background: #fb8c00"></i>
                <span>
                  <b>{{ $t('history.legend_slow') }}</b>
                  <em>{{ $t('history.legend_slow_desc') }}</em>
                </span>
              </div>
              <div class="legend__item">
                <i class="legend__line" style="background: #e53935"></i>
                <span>
                  <b>{{ $t('history.legend_stopped') }}</b>
                  <em>{{ $t('history.legend_stopped_desc') }}</em>
                </span>
              </div>
            </div>

            <p class="text-caption grey--text mt-3 mb-0">
              {{ $t('history.accuracy_note') }}
              <template v-if="marks.length"> {{ $t('history.marked_note') }}</template>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LMap, LTileLayer, LPolyline, LCircleMarker, LMarker, LTooltip } from 'vue2-leaflet';
import L from 'leaflet';
import axios from 'axios';

/** Shenja e nisjes dhe e mbarimit: rrethe me shkronje, jo gjilpera harte. */
const shenja = (ngjyra, shkronja) =>
  L.divIcon({
    className: '',
    html:
      `<div style="width:22px;height:22px;border-radius:50%;background:${ngjyra};` +
      'color:#fff;font:700 12px/22px Arial;text-align:center;' +
      'box-shadow:0 0 0 2px #fff,0 1px 4px rgba(0,0,0,.4)">' +
      shkronja +
      '</div>',
    iconSize: [22, 22],
    iconAnchor: [11, 11],
  });

/**
 * Historiku i levizjes se autobusave.
 *
 * Vija ngjyroset sipas shpejtesise se llogaritur mes dy pikave: e kuqja
 * tregon aty ku autobusi ka qendruar, ndaj pritja duket pa lexuar numra.
 */
export default {
  name: 'RideHistory',

  components: { LMap, LTileLayer, LPolyline, LCircleMarker, LMarker, LTooltip },

  data() {
    return {
      menuDate: false,
      // Data e vendit: me UTC, midis mesnates dhe ores 02:00 hapej
      // dita e djeshme.
      date: new Date().toLocaleDateString('en-CA'),
      sot: new Date().toLocaleDateString('en-CA'),
      rides: [],
      selected: null,
      points: [],
      halts: [],
      marks: [],
      haltIZgjedhur: null,
      kerkimi: '',
      ikonaNisjes: shenja('#2e7d32', 'A'),
      ikonaMbarimit: shenja('#c62828', 'B'),
      loadingRides: false,
      pashDate: false,
      loadingTrack: false,
      zoom: 13,
      center: [42.6629, 21.1655],
      attribution: '&copy; OpenStreetMap',
      tileStyle: ['satellite', 'standard', 'esri', 'terrain'].includes(localStorage.getItem('mapTileStyle'))
        ? localStorage.getItem('mapTileStyle')
        : 'standard',
      tileStyles: [
        { key: 'standard', label: 'Standard' },
        { key: 'satellite', label: 'Satelit' },
        { key: 'esri', label: 'Esri' },
      ],
      tileUrls: {
        satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        standard: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        esri: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      },
    };
  },

  computed: {
    url() {
      return this.tileUrls[this.tileStyle] || this.tileUrls.standard;
    },

    /** Vetem ato qe kane vendndodhje te njohur. */
    marksMeVend() {
      return this.marks.filter((m) => m.lat !== null && m.lng !== null);
    },

    /**
     * Kur nje udhetim eshte i hapur, ne liste mbetet vetem ai. Perndryshe
     * lista filtrohet sipas shoferit ose autobusit.
     */
    listaEDukshme() {
      if (this.selected) {
        return this.rides.filter((r) => r.id === this.selected.id);
      }

      const q = (this.kerkimi || '').trim().toLowerCase();
      if (!q) return this.rides;

      return this.rides.filter(
        (r) =>
          (r.driver_name || '').toLowerCase().includes(q) ||
          (r.bus_name || '').toLowerCase().includes(q)
      );
    },

    pikaENisjes() {
      return this.points.length ? [this.points[0].lat, this.points[0].lng] : null;
    },

    pikaEMbarimit() {
      if (this.points.length < 2) return null;
      const p = this.points[this.points.length - 1];
      return [p.lat, p.lng];
    },

    totalSeconds() {
      return this.halts.reduce((s, h) => s + h.seconds, 0);
    },

    /**
     * Pjese te njepasnjeshme me te njejten ngjyre.
     *
     * Aty ku dy pika japin nje shpejtesi te pamundur, vija nderpritet ne vend
     * qe te vizatohet: eshte kercim i GPS-it, jo levizje. Filtri kryesor rri
     * ne server; ky eshte rrjeta e sigurise per te dhenat e vjetra.
     */
    segments() {
      const segs = [];
      let aktual = null;

      for (let i = 1; i < this.points.length; i++) {
        const a = this.points[i - 1];
        const b = this.points[i];

        if (b.kmh !== null && b.kmh > 150) {
          aktual = null;
          continue;
        }

        const color = this.ngjyra(b.kmh);

        if (aktual && aktual.color === color) {
          aktual.pts.push([b.lat, b.lng]);
        } else {
          aktual = { color, pts: [[a.lat, a.lng], [b.lat, b.lng]] };
          segs.push(aktual);
        }
      }

      return segs;
    },
  },

  mounted() {
    this.loadRides(false);

    // Si te ndjekja live: cepi i hartes mbetet i paster. Kredia e
    // OpenStreetMap-it nuk hiqet, vetem zhvendoset te legjenda poshte —
    // licenca e tyre e kerkon te dukshme.
    this.$nextTick(() => {
      const map = this.$refs.map && this.$refs.map.mapObject;
      if (map && map.attributionControl) map.removeControl(map.attributionControl);
    });
  },

  watch: {
    date() {
      // Ndryshimi qe vjen nga vete pergjigjja e serverit nuk e rithërret.
      if (this.pashDate) { this.pashDate = false; return; }
      this.kerkimi = '';
      this.selected = null;
      this.points = [];
      this.halts = [];
      this.marks = [];
      this.loadRides();
    },
  },

  methods: {
    /** Kthim te lista e plote e udhetimeve te asaj dite. */
    mbyllZgjedhjen() {
      this.selected = null;
      this.points = [];
      this.halts = [];
      this.marks = [];
      this.haltIZgjedhur = null;
    },

    /**
     * Klikimi mbi nje rresht te tabeles e con harten te ai qendrim dhe e
     * zmadhon shenjen, qe te dallohet nga te tjerat.
     */
    shkoTeQendrimi(h, i) {
      this.haltIZgjedhur = this.haltIZgjedhur === i ? null : i;

      const map = this.$refs.map && this.$refs.map.mapObject;
      if (!map || this.haltIZgjedhur === null) return;

      map.setView([h.lat, h.lng], Math.max(map.getZoom(), 17), { animate: true });

      // Harta rri mbi tabele; pa kete, klikimi nuk do te dukej fare.
      this.$nextTick(() => {
        const el = this.$refs.map && this.$refs.map.$el;
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    },

    /** Ruhet nen te njejtin celes si te ndjekja live: nje zgjedhje per te dyja. */
    setTile(key) {
      this.tileStyle = key;
      localStorage.setItem('mapTileStyle', key);
    },

    /**
     * Ora e sakte lokale.
     *
     * Serveri i ruan te gjitha ne UTC dhe i kthen si ISO-8601 me zonen;
     * `moment` e perkthen ne oren e shfletuesit. Pa kete kthim, ora do te
     * dukej dy ore prapa gjate veres.
     */
    koha(v) {
      return v ? this.$moment(v).format('HH:mm:ss') : '';
    },

    ngjyra(kmh) {
      if (kmh === null || kmh < 3) return '#e53935';   // ndalur
      if (kmh < 20) return '#fb8c00';                  // ngadale
      return '#2e7d32';                                // ne levizje
    },

    ora(v) {
      return v ? this.$moment(v).format('HH:mm') : '';
    },

    minuta(sek) {
      if (!sek) return '0 min';
      const m = Math.floor(sek / 60);
      const s = sek % 60;
      return m ? `${m} min ${s ? s + 's' : ''}`.trim() : `${s}s`;
    },

    /**
     * Ne hapjen e pare data nuk dergohet: serveri kthen diten e fundit qe ka
     * vertet gjurme, qe faqja te mos hapet bosh kur sot s'ka ecur asnje
     * autobus. Pas kesaj, data zgjidhet nga perdoruesi.
     */
    async loadRides(meDate = true) {
      this.loadingRides = true;
      try {
        const params = meDate ? { date: this.date } : {};
        const { data } = await axios.get('/rides/history', { params });
        this.rides = data.rides || [];

        if (!meDate && data.date && data.date !== this.date) {
          this.pashDate = true;
          this.date = data.date;
        }
      } catch (e) {
        this.rides = [];
      } finally {
        this.loadingRides = false;
      }
    },

    async open(ride) {
      this.selected = ride;
      this.loadingTrack = true;

      try {
        const { data } = await axios.get(`/rides/${ride.id}/track`);
        this.points = data.points || [];
        this.halts = data.halts || [];
        this.marks = data.marks || [];

        if (this.points.length) {
          this.center = [this.points[0].lat, this.points[0].lng];
          this.$nextTick(() => {
            const map = this.$refs.map && this.$refs.map.mapObject;
            if (map && this.points.length > 1) {
              map.fitBounds(this.points.map((p) => [p.lat, p.lng]), { padding: [30, 30] });
            }
          });
        }
      } catch (e) {
        this.points = [];
        this.halts = [];
        this.marks = [];
      } finally {
        this.loadingTrack = false;
      }
    },
  },
};
</script>

<style>
/* Pa `scoped`: permbajtja e tooltip-it e Leaflet-it vizatohet jashte
   komponentit, ndaj stili i kufizuar nuk do ta prekte. */
.halt-tip {
  font-size: 11px;
  line-height: 1.45;
  max-width: 190px;
}

.halt-tip__head {
  display: flex;
  flex-direction: column;
  margin-bottom: 3px;
}

.halt-tip__head strong {
  font-size: 12.5px;
}

.halt-tip__group {
  margin-top: 4px;
}

.halt-tip__label {
  display: block;
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.halt-tip__names {
  margin: 1px 0 0;
  padding-left: 12px;
  list-style: disc;
}

.halt-tip__names li {
  font-size: 10.5px;
}

/* Rreshtat e qendrimeve jane te klikueshem: e tregojme edhe me kursorin. */
.halt-row {
  cursor: pointer;
}

.halt-row:hover {
  background: rgba(0, 0, 0, 0.03);
}

.halt-row--active {
  background: rgba(46, 125, 50, 0.1) !important;
}

/* Legjenda: te njejtat forma dhe ngjyra si ne harte, qe lidhja te jete e
   menjehershme pa u lexuar teksti. */
/* Kolona qe pershtaten vetvetiu: ne ekran te gjere dalin tri-kater ne rresht,
   ne telefon njera nen tjetren. */
.legend {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(215px, 1fr));
  gap: 8px 20px;
}

.legend__item {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.72);
}

.legend__item b {
  display: block;
  font-weight: 600;
  line-height: 1.3;
}

.legend__item em {
  display: block;
  font-style: normal;
  font-size: 11px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.5);
}

.legend__pin {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  font: 700 10px/18px Arial, sans-serif;
  text-align: center;
  font-style: normal;
  box-shadow: 0 0 0 2px #fff, 0 1px 3px rgba(0, 0, 0, 0.35);
}

.legend__dot {
  flex-shrink: 0;
  margin-top: 3px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid;
}

.legend__line {
  flex-shrink: 0;
  margin-top: 7px;
  width: 22px;
  height: 4px;
  border-radius: 2px;
}

/* Cepi i hartes mbetet i paster; kredia rri te legjenda. */
.leaflet-control-attribution {
  display: none !important;
}
</style>

<style scoped>
.loader-over {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 2;
}
</style>
